define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var $ = require('j');
    var i18n = require('i18n');

    module.exports = {
        /**
         * @param   {Object}    e   BoneEvent or $field
         * @return  {Object}        Form class
         */
        removeInfoTooltip: function(e) {
            var $field = this.$getFieldByEvent(e);
            $field.find('.' + this.infoTooltipClass).remove();
            return this;
        },

        /**
         * @param   {Object}    e   BoneEvent or $field
         * @return  {Object}        Form class
         */
        showInfoTooltipIfNecessary: function(e) {
            var $field = this.$getFieldByEvent(e);
            var config = this.getFieldNotificationConfig($field);
            var message = this.getInfoMessage(config);
            var allowed = this.isInfoTooltipAllowed($field, message);
            if (allowed) {
                this.showInfoTooltip($field, {
                    message: message
                });
            }
            return this;
        },

        getFieldNotificationConfig: function($field) {
            var notificationType = this.getValidationType($field);
            if (notificationType === 'confirmation') {
                var originField = $field.find('input').attr('data-origin-name');

                notificationType = originField + 'Verify';
            }

            return _.get(this, 'options.data.notificationConfig.' + notificationType)
                || _.get(this, 'options.notificationConfig.' + notificationType)
                || _.get(this, ['options', 'data', 'notificationConfig', notificationType])
                || '';
        },

        getValidationType: function($field) {
            var field = $field.get(0);
            var validationType = _.get(field, 'dataset.validationType');
            validationType = validationType || $field.attr('data-validation-type');
            return validationType;
        },

        getInfoMessage: function(config) {
            //Please take a look at user.notification.config
            var message = config;
            message = i18n.t(message) || message;
            return message;
        },

        isInfoTooltipAllowed: function($field, message) {
            var allowedForThisForm = this.isInfoTooltipAllowedForThisForm();
            var freeField = this.isFieldFreeForTooltip($field);
            return message && allowedForThisForm && freeField;
        },

        isInfoTooltipAllowedForThisForm: function() {
            var result = _.get(this, 'options.data.showInfoTooltip') || _.get(this, ['options', 'data', 'showInfoTooltip']);
            result = Boolean(result);
            return result;
        },

        isFieldFreeForTooltip: function($field) {
            return !$field.hasClass('invalid');
        },

        showInfoTooltip: function($field, data) {
            var $infoTooltip = this.$getInfoTooltip($field);
            var message = data.message;
            $infoTooltip.html(message);
            return this;
        },

        infoTooltipClass: 'info-tooltip',

        $getInfoTooltip: function($field) {
            var $infoTooltip = $field.find('.' + this.infoTooltipClass);
            if (!$infoTooltip.length) {
                $infoTooltip = this.$defineInfoTooltip($field);
            }
            return $infoTooltip;
        },

        $defineInfoTooltip: function($field) {
            var infoTooltip = document.createElement('div');
            var $infoTooltip = $(infoTooltip);
            $infoTooltip.addClass(this.infoTooltipClass);
            $field.append($infoTooltip);
            return $infoTooltip;
        },

        $getFieldByEvent: function(e) {
            var $field;
            if (e instanceof $) {
                $field = e;
            } else {
                $field = $(e.currentTarget);
            }
            return $field;
        }
    };
});
